export enum OrderCourierEnum {
  IN_HOUSE = "IN HOUSE",
  O2GO = "2GO",
  LALAMOVE = "LALAMOVE",
  GRAB = "GRAB",
  GRAB_EXPRESS = "GRAB EXPRESS",
  PANDAGO = "PANDAGO",
  PANDAGO_AUTO = "PANDAGO AUTO",
  OTHERS = "OTHERS"
}

export enum RemittanceStatusReasonEnum {
  BANK_IS_OFFLINE = "Bank is offline",
  BANK_HAS_NO_OPERATIONS = "Bank has no operations",
  TECHNICAL_ERRORS = "Tehcnical Errors (Error in Kiosks, System, etc.)",
  OTHERS = "Others"
}
